import { render, staticRenderFns } from "./gBlockTitle.vue?vue&type=template&id=6b2ab554&scoped=true&"
import script from "./gBlockTitle.vue?vue&type=script&lang=js&"
export * from "./gBlockTitle.vue?vue&type=script&lang=js&"
import style0 from "./gBlockTitle.vue?vue&type=style&index=0&id=6b2ab554&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2ab554",
  null
  
)

export default component.exports